export const getSortedList = (list, arrangeState) => {
  const { arrangeByName, arrangeByType, arrangeByGenre, arrangeByAddedDate, arrangeOrder } = arrangeState;

  return [...list].sort((a, b) => {
    const { name: nameA, type: typeA, createdDate: dateA, genres: genresA } = a;
    const { name: nameB, type: typeB, createdDate: dateB, genres: genresB } = b;

    const results = {
      name: 0,
      type: 0,
      date: 0,
      genre: 0
    };

    if (nameA.toLowerCase() < nameB.toLowerCase()) results.name = -1;
    if (nameA.toLowerCase() > nameB.toLowerCase()) results.name = 1;
    if (arrangeByName === 'descending') results.name = -results.name;

    if (typeA.toLowerCase() < typeB.toLowerCase()) results.type = -1;
    if (typeA.toLowerCase() > typeB.toLowerCase()) results.type = 1;
    if (arrangeByType === 'descending') results.type = -results.type;

    if (new Date(dateA) < new Date(dateB)) results.date = -1;
    if (new Date(dateA) > new Date(dateB)) results.date = 1;
    if (arrangeByAddedDate === 'descending') results.date = -results.date;

    if (genresA.join().toLowerCase() < genresB.join().toLowerCase()) results.genre = -1;
    if (genresA.join().toLowerCase() < genresB.join().toLowerCase()) results.genre = 1;
    if (arrangeByGenre === 'descending') results.genre = -results.genre;

    return results[arrangeOrder[0]] || results[arrangeOrder[1]] || results[arrangeOrder[2]];
  });
};